export default {
  path: "/masterData",
  name: "MasterData",
  component: () => import("@/layout/index.vue"),
  // redirect: {
  //     name: "EquipmentMasterData"
  // },
  meta: {
    title: "主数据",
    icon: "iconfont icon-chaxunbaobiao",
    role: "BACK_MENU5"
  },
  children: [
    {
      path: "/material",
      name: "Material",
      component: () => import("@/views/masterData/material.vue"),
      meta: {
        title: "物料主数据",
        role: "BACK_MENU5_M1"
      }
    },
    {
      path: "/personCost",
      name: "PersonCost",
      component: () => import("@/views/masterData/personCost.vue"),
      meta: {
        title: "人员成本中心主数据",
        role: "BACK_MENU5_M1"
      }
    },
    {
      path: "/materialDeploy",
      name: "materialDeploy",
      component: () => import("@/views/masterData/materialDeploy.vue"),
      meta: {
        title: "物料配置主数据",
        role: "BACK_MENU5_M2"
      }
    },
    {
      path: "/vendor",
      name: "Vendor",
      component: () => import("@/views/masterData/vendor.vue"),
      meta: {
        title: "供应商主数据",
        role: "BACK_MENU5_M3"
      }
    },
    {
      path: "/transactionReason",
      name: "TransactionReason",
      component: () => import("@/views/masterData/transactionReason.vue"),
      meta: {
        title: "XA事务类型",
        role: "BACK_MENU5_M4"
      }
    },
    {
      path: "/warearea",
      name: "warearea",
      component: () => import("@/views/masterData/warearea.vue"),
      meta: {
        title: "库区主数据",
        role: "BACK_MENU5_M13"
      }
    },
    {
      path: "/warehouse",
      name: "Warehouse",
      component: () => import("@/views/masterData/warehouse.vue"),
      meta: {
        title: "通道主数据",
        role: "BACK_MENU5_M5"
      }
    },
    {
      path: "/location",
      name: "Location",
      component: () => import("@/views/masterData/location.vue"),
      meta: {
        title: "库位主数据",
        role: "BACK_MENU5_M6"
      }
    },
    {
      path: "/factory",
      name: "Factory",
      component: () => import("@/views/masterData/factory.vue"),
      meta: {
        title: "工厂主数据",
        role: "BACK_MENU5_M7"
      }
    },
    {
      path: "/bom",
      name: "Bom",
      component: () => import("@/views/masterData/bom.vue"),
      meta: {
        title: "BOM主数据",
        role: "BACK_MENU5_M8"
      }
    },
    {
      path: "/employee",
      name: "Employee",
      component: () => import("@/views/masterData/employee.vue"),
      meta: {
        title: "人员主数据",
        role: "BACK_MENU5_M9"
      }
    },
    {
      path: "/department",
      name: "Department",
      component: () => import("@/views/masterData/department.vue"),
      meta: {
        title: "部门主数据",
        role: "BACK_MENU5_M10"
      }
    },
    {
      path: "/pointPosition",
      name: "PointPosition",
      component: () => import("@/views/masterData/pointPosition.vue"),
      meta: {
        title: "仓库站点主数据",
        role: "BACK_MENU5_M11"
      }
    },
    {
      path: "/productionLineStation",
      name: "ProductionLineStation",
      component: () => import("@/views/masterData/productionLineStation.vue"),
      meta: {
        title: "产线站点主数据",
        role: "BACK_MENU5_M12"
      }
    },
    {
      path: "/reinspection",
      name: "reinspection",
      component: () => import("@/views/masterData/reinspection.vue"),
      meta: {
        title: "保质期配置主数据",
        role: "BACK_MENU5_M14"
      }
    },
   /* {
      path: "/user-area-auth",
      name: "UserAreaAuth",
      component: () => import("@/views/masterData/user-area-auth.vue"),
      meta: {
        title: "用户库区权限"
        // role: "BACK_MENU5_M10"
      }
    }*/
  ]
};
